import React, { lazy, Suspense, useEffect } from 'react';
import { Grid, Box, Skeleton, IconButton, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from "@tanstack/react-query";
import { useNavigate, useParams } from 'react-router-dom';
import { fetchClinicianUser } from '../../../utils/clinicialAPI';
import { setSelectedTab, setSelectedTabData } from '../../../slice/profileTabSectionSlice';
import ClinicianQualification from '../Profile/ClinicianQualification';
import ProfileCard from '../Profile/ProfileCard';
import ClinicianExperience from '../Profile/ClinicianExperience';
import ClinicianLicense from '../Profile/ClinicianLicense';
import ClinicianSpecialties from '../Profile/ClinicianSpecialties';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { isValidUUID } from '../../../utils/genericMethod';
// Lazy load components
const About = lazy(() => import('../../ClinicianPages/Profile/About'));
const ClinicianDocuments = lazy(() => import('../../ClinicianPages/Profile/ClinicianDocuments'));

const ViewClinicianProfile = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { selectedTab, selectedTabData, isAllowRefetch, selectedUserId } = useSelector((state) => state.profileTabSection);
    console.log("selectedTabData", selectedTabData)


    const { ID, JOBID } = useParams();

    isValidUUID(JOBID)
    console.log("ID", ID, JOBID);
    const { data, error, isLoading, refetch } = useQuery({
        queryKey: ['clinicianUser', ID],
        queryFn: () => fetchClinicianUser(ID, JOBID),
        enabled: !!ID,
        // staleTime: 1000 * 60 * 2,
    });
//  This will ONLY set "About" if there’s no tab in Redux yet
useEffect(() => {
    if (!selectedTab) {
        dispatch(setSelectedTab('About'));
    }
}, [selectedTab, dispatch]);


    useEffect(() => {
        refetch();
    }, [ID, JOBID, refetch]);

    // console.log("datya", data);
    useEffect(() => {
        if (data) {
            const tabData = {
                about: data?.about,
                license: data?.userLicense,
                specialities: data?.specialty,
                workExperience: data?.userExperience,
                qualification: data?.userQualification,
                disputedTab: data?.disputedTab,
                referenceData: data.referenceData,
                approvedLicenseCount: data.approvedLicenseCount,
                essentialDocuments: data?.essentialDocuments,
                certifications: data?.certifications,
                training: data?.training,
            };
            dispatch(setSelectedTabData(tabData));
        }
    }, [data, dispatch]);

    const renderTabContent = () => {
        switch (selectedTab) {
            case 'About':
                return (
                    
                        <About data={selectedTabData?.about} refetchData={refetch} />

                );
            // case 'Qualification & Language':
            //     return <ClinicianQualification data={selectedTabData?.about?.qualification } />;
            case 'Essential Documents':
                return (<ClinicianDocuments data={selectedTabData?.essentialDocuments} />);
            case 'Credentials':
                return (<>
                    <ClinicianLicense data={selectedTabData?.license} />
                    <ClinicianExperience data={selectedTabData?.workExperience} />
                    <ClinicianSpecialties data={selectedTabData?.specialities} />
                    {/* <ClinicianTraining data={selectedTabData?.license} /> */}
                    <ClinicianQualification data={selectedTabData?.about} />
                </>);
            default:
                return (<About data={selectedTabData?.about} refetchData={refetch} />);
        }
    };

    const renderSkeleton = () => (

        <Box>
            <Skeleton variant="rectangular" width="100%" height={40} />
            <Skeleton variant="rectangular" width="100%" height={200} />
        </Box>
    );

    if (isLoading) {
        return (
            <Box>{renderSkeleton()}</Box>
        );
    }

    if (error) {
        return (
            <Box color="error.main">
                <div>An error occurred: {error.message}</div>
            </Box>
        );
    }
    return (
        <>
            <Box>
                <Grid container>
                    <Box onClick={() => navigate(-1)} sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer', marginLeft: "-15px" }}>
                        <IconButton >
                            <ChevronLeftIcon />
                        </IconButton>
                        <Typography variant="body1" >
                            Back
                        </Typography>
                    </Box>
                    <Grid item xs={12} lg={12}>
                        <ProfileCard
                            customTab={["About", "Essential Documents", "Credentials"]}
                            data={selectedTabData || {}}
                            selectedTab={selectedTab}
                            setSelectedTab={(tab) => dispatch(setSelectedTab(tab))} />
                    </Grid>
                    <Grid item xs={12} lg={12}>
                        <Suspense fallback={renderSkeleton()}>
                            {renderTabContent()}
                        </Suspense>
                    </Grid>
                </Grid>
            </Box>

        </>);

};

export default ViewClinicianProfile;
